import { Button } from "reactstrap";
import { connect } from "react-redux";
import { ImportIcon } from "../../constants/icons";
import "./Button.css";

const DownloadButton = (props) => {
  return (
    <Button className="bomButtons linkBtn download" onClick={props.onClick}>
      <ImportIcon className="icon" />
      <div className="text">Download</div>
    </Button>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps, {})(DownloadButton);
